export const BUTTON_TYPE_CLASSES = {
  BASE: "base",
  GOOGLE: "google-sign-in",
  INVERTED: "inverted",
};
